import { toSimplified } from '../utils/zhConverter';

const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

// Step 1: Load all translation files normally
Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as { default?: Record<string, string> };

    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }

    if (module.default) {
      messages[lang].translation = {
        ...messages[lang].translation,
        ...module.default,
      };
    }
  }
});

// Step 2: If zh-Hant exists but zh-Hans does not (because it was deleted),
// auto-generate zh-Hans by converting all zh-Hant translation values
if (messages['zh-Hant'] && !messages['zh-Hans']) {
  const tradTranslations = messages['zh-Hant'].translation;
  const simpTranslations: Record<string, string> = {};

  for (const [key, value] of Object.entries(tradTranslations)) {
    simpTranslations[key] = toSimplified(value);
  }

  messages['zh-Hans'] = { translation: simpTranslations };
}

// Step 3: Conversely, if zh-Hans exists but zh-Hant does not,
// use zh-Hans as the source (covers edge case)
if (messages['zh-Hans'] && !messages['zh-Hant']) {
  const simpTranslations = messages['zh-Hans'].translation;
  messages['zh-Hant'] = { translation: simpTranslations };
}

export default messages;